module.exports = __webpack_public_path__ + "img/revolver.d3889492.jpeg";